
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transaction-streaming",
      function () {
        return require("private-next-pages/transaction-streaming.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transaction-streaming"])
      });
    }
  